import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
import _imports_0 from '@/assets/logo.png';
const _hoisted_1 = {
  class: "img-digtal"
};
const _hoisted_2 = {
  class: "img-digtal-header"
};
const _hoisted_3 = {
  class: "doc-header-left"
};
const _hoisted_4 = {
  class: "img-digtal-main"
};
const _hoisted_5 = {
  class: "iframe-container"
};
const _hoisted_6 = {
  class: "upload-section"
};
const _hoisted_7 = {
  class: "scroll-content"
};
const _hoisted_8 = {
  class: "step-header"
};
const _hoisted_9 = {
  class: "step-desc"
};
const _hoisted_10 = {
  class: "upload-area"
};
const _hoisted_11 = {
  class: "upload-content"
};
const _hoisted_12 = {
  class: "upload-left"
};
const _hoisted_13 = {
  class: "upload-right"
};
const _hoisted_14 = {
  class: "upload-requirements"
};
const _hoisted_15 = {
  class: "requirement-item"
};
const _hoisted_16 = {
  class: "requirement-item"
};
const _hoisted_17 = {
  class: "requirement-item warning"
};
const _hoisted_18 = {
  key: 1,
  class: "upload-content"
};
const _hoisted_19 = {
  class: "image-loading"
};
const _hoisted_20 = {
  class: "name-input-area"
};
const _hoisted_21 = {
  class: "step-header"
};
const _hoisted_22 = {
  class: "input-wrapper"
};
const _hoisted_23 = {
  class: "input-area"
};
const _hoisted_24 = {
  class: "input-mode-tabs"
};
const _hoisted_25 = {
  class: "tabs-wrapper"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  key: 0,
  class: "mode-content",
  style: {
    "min-height": "80px"
  }
};
const _hoisted_28 = {
  class: "upload-voice-wrapper"
};
const _hoisted_29 = {
  key: 1,
  class: "audio-file-preview"
};
const _hoisted_30 = {
  class: "audio-info"
};
const _hoisted_31 = {
  class: "file-name"
};
const _hoisted_32 = {
  class: "action-buttons"
};
const _hoisted_33 = {
  key: 1,
  class: "mode-content"
};
const _hoisted_34 = {
  class: "record-controls"
};
const _hoisted_35 = {
  class: "record-timer"
};
const _hoisted_36 = {
  key: 2,
  class: "mode-content"
};
const _hoisted_37 = {
  class: "text-input-wrapper"
};
const _hoisted_38 = {
  class: "input-header"
};
const _hoisted_39 = {
  class: "header-left"
};
const _hoisted_40 = {
  class: "voice-icon-wrapper"
};
const _hoisted_41 = {
  class: "voice-name"
};
const _hoisted_42 = {
  class: "input-container"
};
const _hoisted_43 = {
  class: "input-footer"
};
const _hoisted_44 = {
  class: "input-tips"
};
const _hoisted_45 = {
  class: "bottom-actions"
};
const _hoisted_46 = {
  class: "status-text",
  style: {
    "opacity": "0"
  }
};
const _hoisted_47 = {
  class: "preview-section"
};
const _hoisted_48 = {
  class: "preview-title",
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_49 = ["src"];
const _hoisted_50 = {
  class: "dialog-content"
};
const _hoisted_51 = {
  class: "voice-selector-box"
};
const _hoisted_52 = ["onClick"];
const _hoisted_53 = ["onClick"];
const _hoisted_54 = {
  class: "icon-wrapper"
};
const _hoisted_55 = {
  class: "voice-item-name"
};
const _hoisted_56 = {
  class: "voice-item-name-main"
};
const _hoisted_57 = {
  class: "voice-item-name-sub"
};
const _hoisted_58 = {
  class: "voice-item-check"
};
const _hoisted_59 = {
  class: "voice-details"
};
const _hoisted_60 = {
  class: "dialog-footer"
};
import { ref, computed, onUnmounted, onMounted } from 'vue';
import { ArrowLeft, Plus, Picture, Loading, Microphone, VideoPause, Upload, Delete, InfoFilled, VideoPlay, Headset, SwitchButton, View, Warning } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import DirectUploader from "@/components/DirectUploader/index.vue";
import { useRoute, useRouter } from 'vue-router';
import { createVideoByPhoto } from "@/request/customrize.ts";
import { useAudioPlayer } from '@/hooks/useAudioPlayer.ts';
import { getAppVideoDetail, describeTimbre, generateAudio, getProgress } from '@/request/index';
import { PollingTimer } from "@/utils/pollingTimer";
import TimbreEditor from '@/components/PdfVoiceSelector/TimbreEditor.vue';
import { blobDownloadUpgrades } from "@/utils";
import { calculateAudioDuration } from '@/utils/audioDuration';
import { useUpload } from '@/hooks/useUpload';
import { imgDigitalAvatarDriver, driverTypeStorage } from "@/utils/driver.ts";
// 新增获取当前日期的方法
export default /*@__PURE__*/_defineComponent({
  __name: 'imgDigitalAvatarVid',
  setup(__props) {
    var _route$query;
    const {
      startGuide,
      driverType
    } = imgDigitalAvatarDriver();
    let showImageViewer = ref(false);
    let showImageArr = ref(['https://virtualhuman-cos-test-1251316161.cos.ap-nanjing.myqcloud.com/prod/resource-manager/small/903/10561/10613/model_16594_20240321160803/preview.png']);
    onMounted(() => {
      // 如果用户没看过指引就显示
      if (!driverTypeStorage.exists(driverType)) {
        startGuide();
      }
    });
    const route = useRoute();
    const router = useRouter();
    /**
     * 表单数据类型定义
     */
    const getCurrentDate = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}${month}${day}${hours}${minutes}${seconds}`;
    };
    // 表单数据响应式对象
    const formData = ref({
      activeMode: 'upload',
      content: '',
      audioUrl: '',
      audioFile: null,
      name: getCurrentDate(),
      imageUrl: ''
    });
    // 状态数据响应式对象
    const state = ref({
      generating: false,
      hasPreview: false,
      imageUploadLoading: false,
      audioUploadLoading: false,
      recordLoading: false,
      previewLoading: false,
      audioGenerating: false // 新增音频合成loading状态
    });
    // 引入音频播放相关方法
    const {
      isPlaying,
      toggle,
      pause,
      duration
    } = useAudioPlayer();
    // 获取详情
    let getAppVideoDetailFn = (id = null) => {
      if (!id) return;
      getAppVideoDetail(id).then(res => {
        let {
          code,
          data
        } = res.data;
        if (code === 200 && data.videoMakeMediaUrl) {
          formData.value.videoMakeMediaUrl = data.videoMakeMediaUrl;
          state.value.hasPreview = true;
        }
      });
    };
    getAppVideoDetailFn((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.id);
    /**
     * 录音相关变量
     */
    const recordTime = ref(0); // 录音时长
    const isRecording = ref(false); // 是否正在录音
    let mediaRecorder = null; // 媒体录制器
    let recordTimer = null; // 录音计时器
    let audioChunks = []; // 音频数据块
    /**
     * 计算属性
     */
    // 是否可以生成视频
    const canGenerate = computed(() => {
      const {
        imageUrl,
        name,
        content,
        audioUrl
      } = formData.value;
      return imageUrl && name && audioUrl;
    });
    // 是否已上传图片
    const hasUploadedImage = computed(() => !!formData.value.imageUrl);
    // 文字数量是否超出警告范围(100-1800字)
    const isWordCountWarning = computed(() => {
      const length = formData.value.content.length;
      return length > 1800 || length < 100;
    });
    // 是否可以预览音频
    const canPreviewAudio = computed(() => {
      return formData.value.audioUrl;
    });
    /**
     * 文件上传相关方法
     */
    // 图片上传前验证
    const handleBeforeUpload = file => {
      const isValidFormat = ['image/jpeg', 'image/png', 'image/webp', 'image/jpeg'].includes(file.type);
      const isLt16M = file.size / 1024 / 1024 < 16;
      if (!isValidFormat) {
        ElMessage.error('只能上传JPG/PNG/WEBP/JPEG格式的图片!');
        return false;
      }
      if (!isLt16M) {
        ElMessage.error('图片大小不能超过16MB!');
        return false;
      }
      state.value.imageUploadLoading = true; // 使用图片loading
      return true;
    };
    // 音频上传前验证
    const handleBeforeVoiceUpload = async file => {
      const isValidFormat = ['audio/mp3', 'audio/wav', 'audio/mpeg'].includes(file.type);
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isValidFormat) {
        ElMessage.error('只能上传MP3/WAV/MPEG格式的音频!');
        return false;
      }
      if (!isLt20M) {
        ElMessage.error('音频大小不能超过20MB!');
        return false;
      }
      // 检查音频时长
      try {
        const duration = await calculateAudioDuration(URL.createObjectURL(file));
        if (duration < 5) {
          ElMessage.error('音频时长不能少于5秒!');
          return false;
        }
      } catch (err) {
        console.error('检查音频时长失败:', err);
        return false;
      }
      pause();
      state.value.audioUploadLoading = true; // 使用音频loading
      return true;
    };
    /**
     * 上传回调处理方法
     */
    // 图片上传成功回调
    const handleSuccess = res => {
      state.value.imageUploadLoading = false;
      if (res.code === 200) {
        formData.value.imageUrl = res.data.url;
        ElMessage.success('上传成功');
      } else {
        handleError('image');
      }
    };
    // 音频上传成功回调
    const handleVoiceSuccess = res => {
      state.value.audioUploadLoading = false;
      if (res.code === 200) {
        formData.value.audioUrl = res.data.url;
        ElMessage.success('音频上传成功');
      } else {
        handleError('audio');
      }
    };
    // 上传失败处理
    const handleError = type => {
      if (type === 'image') {
        state.value.imageUploadLoading = false;
      } else {
        state.value.audioUploadLoading = false;
      }
      ElMessage.error('上传失败');
    };
    // 添加录音上传实例
    const audioUploader = useUpload({
      beforeUpload: file => {
        // 验证音频文件
        const isValidFormat = ['audio/wav', 'audio/mpeg', 'audio/mp3'].includes(file.type);
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!isValidFormat) {
          ElMessage.error('只支持MP3/WAV格式的音频!');
          return false;
        }
        if (!isLt20M) {
          ElMessage.error('音频大小不能超过20MB!');
          return false;
        }
        return true;
      },
      onSuccess: (response, file) => {
        formData.value.audioUrl = response.url;
        state.value.recordLoading = false;
        ElMessage.success('录音上传成功');
      },
      onError: error => {
        ElMessage.error(`录音上传失败: ${error.message}`);
        state.value.recordLoading = false;
      }
    });
    /**
     * 录音相关方法
     */
    // 开始/停止录音
    const toggleRecording = async () => {
      if (!isRecording.value) {
        try {
          // 获取麦克风权限并开始录音
          const stream = await navigator.mediaDevices.getUserMedia({
            audio: true
          });
          mediaRecorder = new MediaRecorder(stream);
          audioChunks = [];
          // 收集音频数据
          mediaRecorder.ondataavailable = e => {
            audioChunks.push(e.data);
          };
          // 录音结束后处理
          mediaRecorder.onstop = async () => {
            try {
              // 将录音数据合并为Blob
              const audioBlob = new Blob(audioChunks, {
                type: 'audio/wav'
              });
              // 创建文件对象
              const audioFile = new File([audioBlob], 'recording.wav', {
                type: 'audio/wav'
              });
              // 上传录音文件
              await audioUploader.upload(audioFile);
            } catch (error) {
              console.error('录音处理失败:', error);
              ElMessage.error('录音处理失败');
              state.value.recordLoading = false;
            }
          };
          // 开始录音
          mediaRecorder.start();
          isRecording.value = true;
          recordTime.value = 0;
          state.value.recordLoading = false;
          // 开始计时,限制最长录制时间为5分钟
          recordTimer = window.setInterval(() => {
            recordTime.value++;
            if (recordTime.value >= 300) {
              stopRecording();
            }
          }, 1000);
        } catch (err) {
          state.value.recordLoading = false;
          ElMessage.error('无法访问麦克风');
        }
      } else {
        stopRecording();
      }
    };
    // 停止录音
    const stopRecording = () => {
      if (mediaRecorder && mediaRecorder.state !== 'inactive') {
        state.value.recordLoading = true;
        mediaRecorder.stop();
        mediaRecorder.stream.getTracks().forEach(track => track.stop());
      }
      if (recordTimer) {
        clearInterval(recordTimer);
      }
      isRecording.value = false;
    };
    /**
     * 模式切换相关方法
     */
    // 切换输入模式
    const switchMode = async mode => {
      const hasContent = formData.value.content || formData.value.audioUrl || formData.value.audioFile;
      if (hasContent) {
        try {
          // 有内容时提示确认
          await ElMessageBox.confirm('切换输入方式将清空当前内容，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
          clearContent();
          formData.value.activeMode = mode;
        } catch {
          return;
        }
      } else {
        formData.value.activeMode = mode;
      }
    };
    /**
     * 内容处理相关方法
     */
    // 清空内容
    const clearContent = () => {
      formData.value.content = '';
      formData.value.audioUrl = '';
      formData.value.audioFile = null;
    };
    // 文本输入处理(过滤特殊字符)
    const handleTextInput = value => {
      formData.value.content = value.replace(/[^\u4e00-\u9fa5a-zA-Z0-9，。！？、：；''""（）\s]/g, '');
    };
    // 验证文本内容
    const validateContent = () => {
      if (!formData.value.content.trim()) {
        ElMessage.warning('请输入文本内容');
        return false;
      }
      if (formData.value.content.length < 50) {
        ElMessage.warning('文本内容不能少于50字');
        return false;
      }
      return true;
    };
    /**
     * 工具方法
     */
    // 格式化时间
    const formatTime = seconds => {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };
    // 获取文件名
    const getFileName = url => {
      if (!url) return '';
      return url.split('/').pop() || '';
    };
    /**
     * 音频预览
     */
    const previewAudio = () => {
      toggle(formData.value.audioUrl);
    };
    // 音频情绪列表
    const voiceList = ref([]);
    const dialogVisible = ref(false);
    const getVoiceData = () => {
      describeTimbre({
        pageIndex: 1,
        pageSize: 200
      }).then(res => {
        const {
          code,
          data,
          msg
        } = res.data;
        if (code == 200) {
          voiceList.value = data.list;
          // .filter((item: any) => !props.platformId || item.platformId == props.platformId);
          // if (props.voiceId) {
          //   selectedVoiceItem.value = voiceList.value.find((item: any) => item.id == props.voiceId) || {};
          // }
        }
      });
    };
    getVoiceData();
    const tempSelectedVoice = ref({});
    const handleEmotionClick = emotion => {
      tempSelectedVoice.value.extendId = (emotion === null || emotion === void 0 ? void 0 : emotion.id) || '';
    };
    // 引入音频播放相关方法
    const {
      isPlaying: audioPlaying,
      toggle: aduioToggle,
      pause: audioPause
    } = useAudioPlayer();
    const openVoiceSelector = ({
      timbreSample
    }) => {
      audioPause();
      aduioToggle(timbreSample);
    };
    const quickSelectVoice = voice => {
      tempSelectedVoice.value = voice;
      // comfirmSelectVoice();
    };
    let comfirmSelectVoice = () => {
      dialogVisible.value = false;
    };
    // 合成音频
    let generateAudioProgress = null;
    const clickGenerateAudio = () => {
      var _tempSelectedVoice$va;
      // 添加音色校验
      if (!((_tempSelectedVoice$va = tempSelectedVoice.value) !== null && _tempSelectedVoice$va !== void 0 && _tempSelectedVoice$va.timbreName)) {
        ElMessage.warning('请先选择音色');
        return Promise.reject('请先选择音色');
      }
      return new Promise((resolve, reject) => {
        state.value.audioGenerating = true;
        let audioParams = {
          ...tempSelectedVoice.value,
          speed: 1,
          timbreId: tempSelectedVoice.value.id,
          aiGenerateWord: formData.value.content,
          inputSsml: formData.value.content
        };
        generateAudio(audioParams).then(res => {
          let {
            code,
            data,
            msg
          } = res.data;
          if (code === 200) {
            pause();
            // 创建轮询实例监��音频合成进度
            generateAudioProgress = setInterval(() => {
              getProgress(data).then(progressRes => {
                const {
                  code,
                  data
                } = progressRes.data;
                if (code == 200) {
                  const {
                    progress,
                    failMessage,
                    mediaUrl,
                    status
                  } = data;
                  if (status === 'FAIL') {
                    clearInterval(generateAudioProgress);
                    state.value.audioGenerating = false;
                    reject(new Error(failMessage));
                  }
                  if (progress === 100) {
                    formData.value.audioUrl = mediaUrl;
                    clearInterval(generateAudioProgress);
                    state.value.audioGenerating = false;
                    resolve(mediaUrl);
                  }
                }
              });
            }, 2000);
          } else {
            state.value.audioGenerating = false;
            reject(new Error(msg));
          }
        }).catch(err => {
          state.value.audioGenerating = false;
          reject(err);
        });
      });
    };
    // 查询合成进度
    const getAudioProgress = params => {
      getProgress(params).then(res => {
        const {
          code,
          data
        } = res.data;
        if (code == 200) {
          const {
            progress,
            failMessage,
            mediaUrl,
            textTimestampResult,
            duration,
            status
          } = data;
          if (status === 'FAIL') {
            clearInterval(generateAudioProgress);
            state.value.audioGenerating = false; // 失败时关闭loading
            ElMessage({
              message: failMessage,
              type: 'error'
            });
          }
          if (progress === 100) {
            formData.value.audioUrl = mediaUrl;
            clearInterval(generateAudioProgress);
            state.value.audioGenerating = false; // 完成时关闭loading
            ElMessage({
              message: '音频已合成！',
              type: 'success'
            });
            formData.value.audioUrl = mediaUrl;
          }
        } else if (code === 7001) {
          clearInterval(generateAudioProgress);
          state.value.audioGenerating = false; // 失败时关闭loading
          ElMessage({
            message: '合成失败',
            type: 'error'
          });
        }
      });
    };
    /**
     * 提取轮询逻辑为独立函数
     */
    const updateVideoStatus = async () => {
      try {
        const result = await getAppVideoDetail(formData.value.videoId);
        console.log('resultresult', result);
        const {
          data: detailData,
          code: detailCode
        } = result.data;
        if (detailCode !== 200) {
          state.value.previewLoading = false; // 失败时关闭loading
          return true;
        }
        const {
          videoMakeStatus,
          videoMakeMediaUrl
        } = detailData;
        if (videoMakeStatus === 'SUCCESS') {
          formData.value.videoMakeMediaUrl = videoMakeMediaUrl;
          ElMessage.success('视频生成成功');
          state.value.hasPreview = true;
          state.value.previewLoading = false; // 成功时关闭loading
          return true; // 停止轮询
        }
        if (videoMakeStatus === 'FAIL') {
          ElMessage.error('视频生成失败：所上传图片中人脸辨识度极低，抑或图片像素欠佳，请重新上传合适的图片。');
          state.value.previewLoading = false; // 失败时关闭loading
          return true; // 停止轮询
        }
        return false; // 继续轮询
      } catch (err) {
        console.error('视频状态轮询出错:', err);
        state.value.previewLoading = false; // 异常时关闭loading
        return true; // 出错停止轮询
      }
    };
    let pollingTimer = null;
    /**
     * 生成视频
     */
    const generateVideo = async () => {
      if (formData.value.activeMode === 'text' && !validateContent()) {
        return;
      }
      state.value.generating = true;
      state.value.previewLoading = true; // 设置预览loading
      try {
        let duration = await calculateAudioDuration(formData.value.audioUrl);
        const params = {
          text: formData.value.content,
          audioUrl: formData.value.audioUrl,
          imageUrl: formData.value.imageUrl,
          name: formData.value.name,
          virtualManType: 99,
          timbreName: '音频驱动',
          duration: duration * 1000
        };
        const res = await createVideoByPhoto(params);
        const {
          code,
          data,
          msg
        } = res.data;
        if (code === 200) {
          formData.value.videoId = data.videoId;
          // 创建轮询实例
          pollingTimer = new PollingTimer(updateVideoStatus, 2000);
          // 开始轮询
          pollingTimer.start();
        } else {
          state.value.previewLoading = false; // 失败时关闭loading
        }
      } catch (error) {
        console.error('生成视频失败:', error);
        state.value.previewLoading = false; // 异常时关闭loading
      } finally {
        state.value.generating = false;
      }
    };
    // 组件卸载时清理轮询
    onUnmounted(() => {
      if (pollingTimer) {
        pollingTimer.cancel();
      }
    });
    // 删除音频文件
    const handleDeleteAudio = () => {
      formData.value.audioUrl = '';
      formData.value.audioFile = null;
      pause();
    };
    /**
     * 常量定义
     */
    // 输入模式选项
    const inputModes = [{
      label: '语音上传',
      value: 'upload'
    }, {
      label: '语音录制',
      value: 'record'
    }, {
      label: '文本输入',
      value: 'text'
    }];
    const handleVoiceSwitch = () => {
      dialogVisible.value = true;
    };
    // 添加检查函数
    const checkRequiredFields = () => {
      const checks = [{
        field: 'imageUrl',
        message: '请上传照片'
      }, {
        field: 'name',
        message: '请输入视频名称'
      }, ...(formData.value.activeMode !== 'text' ? [{
        field: 'audioUrl',
        message: '请添加音频内容'
      }] : [])];
      const missingField = checks.find(({
        field
      }) => !formData.value[field]);
      return (missingField === null || missingField === void 0 ? void 0 : missingField.message) || '';
    };
    // 生成按钮提示文案
    const generateButtonTip = computed(() => {
      return checkRequiredFields() || '点击生成视频';
    });
    // 处理生成按钮点击
    const handleGenerateClick = async () => {
      const missingTip = checkRequiredFields();
      if (missingTip) {
        ElMessage.warning(missingTip);
        return;
      }
      // 检查是否为文本输入模式且需要合成音频
      if (formData.value.activeMode === 'text' && !formData.value.audioUrl) {
        var _tempSelectedVoice$va2;
        // 验证文本和音色是否已选择
        if (!formData.value.content || !((_tempSelectedVoice$va2 = tempSelectedVoice.value) !== null && _tempSelectedVoice$va2 !== void 0 && _tempSelectedVoice$va2.timbreName)) {
          ElMessage.warning('请输入文本内容并选择音色');
          return;
        }
        // 先合成音频
        try {
          await clickGenerateAudio();
        } catch (err) {
          console.error("添加失败！:", err);
          return;
        }
      }
      // 继续生成视频流程
      generateVideo();
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_link = _resolveComponent("el-link");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_Check = _resolveComponent("Check");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        class: "back-btn",
        link: "",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).back())
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(ArrowLeft))]),
          _: 1
        }), _cache[11] || (_cache[11] = _createTextVNode(" 返回 "))]),
        _: 1
      })]), _cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "doc-header-right"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "公司logo",
        class: "company-logo"
      })], -1))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "step-number"
      }, "01", -1)), _cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "step-title"
      }, "上传照片", -1)), _createElementVNode("div", _hoisted_9, [_cache[14] || (_cache[14] = _createTextVNode(" 请上传一张清晰的正面照片，将用于生成数字人形象 ")), _createVNode(_component_el_tooltip, {
        content: "查看示例",
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          link: "",
          class: "preview-example-btn",
          onClick: _cache[1] || (_cache[1] = $event => _isRef(showImageViewer) //@ts-ignore
          ? showImageViewer.value = true : showImageViewer = true)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(View))]),
            _: 1
          }), _cache[13] || (_cache[13] = _createTextVNode(" 点击查看示例图片 "))]),
          _: 1
        })]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_10, [_withDirectives((_openBlock(), _createBlock(DirectUploader, {
        "show-file-list": false,
        config: {
          drag: true
        },
        "before-upload": handleBeforeUpload,
        "on-success": handleSuccess,
        "on-error": () => handleError('image')
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(["upload-trigger", {
            'has-file': formData.value.imageUrl
          }])
        }, [!formData.value.imageUrl ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_icon, {
          class: "upload-icon"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Plus))]),
          _: 1
        }), _cache[17] || (_cache[17] = _createElementVNode("span", {
          class: "upload-text"
        }, "点击或拖拽照片上传", -1)), _cache[18] || (_cache[18] = _createElementVNode("div", {
          class: "upload-tip"
        }, "支持格式：jpg、png、webp，建议大小不超过16MB", -1))]), _createElementVNode("div", _hoisted_13, [_cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "requirements-title"
        }, "上传要求", -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Picture))]),
          _: 1
        }), _cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "requirement-content"
        }, [_createElementVNode("div", {
          class: "requirement-label"
        }, "照片类型"), _createElementVNode("div", {
          class: "requirement-desc"
        }, "肖像或半身照正视图最佳")], -1))]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(View))]),
          _: 1
        }), _cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "requirement-content"
        }, [_createElementVNode("div", {
          class: "requirement-label"
        }, "清晰度要求"), _createElementVNode("div", {
          class: "requirement-desc"
        }, "五官清晰可见")], -1))]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Warning))]),
          _: 1
        }), _cache[21] || (_cache[21] = _createElementVNode("div", {
          class: "requirement-content"
        }, [_createElementVNode("div", {
          class: "requirement-label"
        }, "重要提示"), _createElementVNode("div", {
          class: "requirement-desc"
        }, "脸部比例过小可能导致生成失败")], -1))])])])]), _cache[23] || (_cache[23] = _createElementVNode("div", {
          class: "upload-border"
        }, null, -1))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_el_image, {
          src: formData.value.imageUrl,
          fit: "contain",
          style: {
            "height": "100%"
          }
        }, {
          placeholder: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_icon, {
            class: "loading-icon"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Loading))]),
            _: 1
          })])]),
          _: 1
        }, 8, ["src"])]))], 2)]),
        _: 1
      }, 8, ["on-error"])), [[_directive_loading, state.value.imageUploadLoading]]), formData.value.imageUrl ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "danger",
        class: "delete-img-btn",
        onClick: _cache[2] || (_cache[2] = $event => formData.value.imageUrl = '')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        }), _cache[24] || (_cache[24] = _createTextVNode(" 删除图片 "))]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
        class: "step-number",
        onClick: _cache[3] || (_cache[3] =
        //@ts-ignore
        (...args) => _ctx.test && _ctx.test(...args))
      }, "02"), _cache[25] || (_cache[25] = _createElementVNode("div", {
        class: "step-title"
      }, "视频名称", -1)), _cache[26] || (_cache[26] = _createElementVNode("div", {
        class: "step-desc"
      }, "为生成的视频取个名字", -1))]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_input, {
        modelValue: formData.value.name,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.name = $event),
        placeholder: "请输入视频名称",
        maxlength: "50",
        "show-word-limit": "",
        clearable: ""
      }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_23, [_cache[35] || (_cache[35] = _createElementVNode("div", {
        class: "step-header"
      }, [_createElementVNode("div", {
        class: "step-number"
      }, "03"), _createElementVNode("div", {
        class: "step-title"
      }, "输入内容"), _createElementVNode("div", {
        class: "step-desc"
      }, "选择输入方式并录入需要播报的内容")], -1)), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(inputModes, tab => {
        return _createElementVNode("div", {
          class: _normalizeClass(["tab-item", {
            active: formData.value.activeMode === tab.value
          }]),
          key: tab.value,
          onClick: $event => switchMode(tab.value)
        }, _toDisplayString(tab.label), 11, _hoisted_26);
      }), 64))]), canPreviewAudio.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        link: "",
        class: "preview-btn",
        onClick: previewAudio,
        loading: state.value.audioGenerating,
        disabled: state.value.audioGenerating
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [!_unref(isPlaying) ? (_openBlock(), _createBlock(_unref(VideoPlay), {
            key: 0
          })) : (_openBlock(), _createBlock(_unref(VideoPause), {
            key: 1
          }))]),
          _: 1
        }), _createTextVNode(" " + _toDisplayString(state.value.audioGenerating ? '合成中...' : '试听'), 1)]),
        _: 1
      }, 8, ["loading", "disabled"])) : _createCommentVNode("", true)]), formData.value.activeMode === 'upload' ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_withDirectives((_openBlock(), _createBlock(DirectUploader, {
        "show-file-list": false,
        "before-upload": handleBeforeVoiceUpload,
        "on-success": handleVoiceSuccess,
        "on-error": () => handleError('audio')
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [!formData.value.audioUrl ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_button, null, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Upload))]),
            _: 1
          }), _cache[27] || (_cache[27] = _createTextVNode(" 上传音频 "))]),
          _: 1
        }), _cache[28] || (_cache[28] = _createElementVNode("div", {
          class: "upload-tip"
        }, "支持格式：mp3、wav，时长不超过5分钟", -1))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_el_icon, {
          class: "music-icon"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Headset))]),
          _: 1
        }), _createElementVNode("span", _hoisted_31, _toDisplayString(getFileName(formData.value.audioUrl)), 1)]), _createElementVNode("div", _hoisted_32, [_createVNode(_component_el_button, {
          type: "primary",
          link: "",
          class: "action-btn"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Upload))]),
            _: 1
          }), _cache[29] || (_cache[29] = _createTextVNode(" 重新上传 "))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          link: "",
          class: "action-btn",
          onClick: _withModifiers(handleDeleteAudio, ["stop"])
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Delete))]),
            _: 1
          }), _cache[30] || (_cache[30] = _createTextVNode(" 删除文件 "))]),
          _: 1
        })])]))])]),
        _: 1
      }, 8, ["on-error"])), [[_directive_loading, state.value.audioUploadLoading]])])) : _createCommentVNode("", true), formData.value.activeMode === 'record' ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(formatTime(recordTime.value)), 1), _createVNode(_component_el_button, {
        type: isRecording.value ? 'danger' : 'primary',
        onClick: toggleRecording,
        loading: state.value.recordLoading
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [!isRecording.value ? (_openBlock(), _createBlock(_unref(Microphone), {
            key: 0
          })) : (_openBlock(), _createBlock(_unref(VideoPause), {
            key: 1
          }))]),
          _: 1
        }), _createTextVNode(" " + _toDisplayString(isRecording.value ? '停止录音' : '开始录音'), 1)]),
        _: 1
      }, 8, ["type", "loading"])])])) : _createCommentVNode("", true), formData.value.activeMode === 'text' ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_cache[32] || (_cache[32] = _createElementVNode("span", {
        class: "input-title"
      }, "文本内容", -1)), _createVNode(_component_el_button, {
        class: "voice-switch-btn",
        onClick: handleVoiceSwitch
      }, {
        default: _withCtx(() => {
          var _tempSelectedVoice$va3;
          return [_createElementVNode("div", _hoisted_40, [_createVNode(_component_el_avatar, {
            size: 24,
            src: require('@/assets/images/FadLogoAudiobus.png'),
            class: "voice-avatar"
          }, null, 8, ["src"]), _cache[31] || (_cache[31] = _createElementVNode("div", {
            class: "pulse-ring"
          }, null, -1))]), _createElementVNode("span", _hoisted_41, _toDisplayString(((_tempSelectedVoice$va3 = tempSelectedVoice.value) === null || _tempSelectedVoice$va3 === void 0 ? void 0 : _tempSelectedVoice$va3.timbreName) || '请选择需要的音色'), 1), _createVNode(_component_el_icon, {
            class: "switch-icon"
          }, {
            default: _withCtx(() => [_createVNode(_unref(SwitchButton))]),
            _: 1
          })];
        }),
        _: 1
      })])]), _createElementVNode("div", _hoisted_42, [_createVNode(_component_el_input, {
        modelValue: formData.value.content,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.value.content = $event),
        type: "textarea",
        rows: 6,
        placeholder: "请输入需要转换的文字内容，建议输50-200字",
        maxlength: 2000,
        "show-word-limit": "",
        onInput: handleTextInput,
        class: "custom-textarea"
      }, null, 8, ["modelValue"]), _cache[33] || (_cache[33] = _createElementVNode("div", {
        class: "input-glow"
      }, null, -1))]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
        _: 1
      }), _cache[34] || (_cache[34] = _createElementVNode("span", null, "在文本框输入内容，选好心仪音色，点击\"文本合成音频\"，快速生成音频。 ", -1))]), _createElementVNode("div", null, [formData.value.content ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "danger",
        link: "",
        onClick: clearContent
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), canPreviewAudio.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        type: "primary",
        round: "",
        onClick: previewAudio,
        loading: state.value.audioGenerating,
        disabled: state.value.audioGenerating
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [!_unref(isPlaying) ? (_openBlock(), _createBlock(_unref(VideoPlay), {
            key: 0
          })) : (_openBlock(), _createBlock(_unref(VideoPause), {
            key: 1
          }))]),
          _: 1
        })]),
        _: 1
      }, 8, ["loading", "disabled"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        type: "primary",
        class: "preview-btn",
        onClick: clickGenerateAudio,
        loading: state.value.audioGenerating,
        disabled: formData.value.content && state.value.audioGenerating
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(formData.value.audioUrl ? '重新合成音频' : '文本合成音频'), 1)]),
        _: 1
      }, 8, ["loading", "disabled"])])])])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_cache[37] || (_cache[37] = _createTextVNode(" 照片数字人尚未开通 ")), _createVNode(_component_el_link, {
        type: "primary",
        class: "open-service"
      }, {
        default: _withCtx(() => _cache[36] || (_cache[36] = [_createTextVNode("前往开通")])),
        _: 1
      })]), _createVNode(_component_el_button, {
        type: "primary",
        style: {
          "width": "30%"
        },
        class: "generate-btn",
        disabled: state.value.generating || state.value.audioGenerating || state.value.previewLoading,
        loading: state.value.generating || state.value.previewLoading,
        onClick: handleGenerateClick
      }, {
        default: _withCtx(() => _cache[38] || (_cache[38] = [_createTextVNode(" 生成视频 ")])),
        _: 1
      }, 8, ["disabled", "loading"])])]), _createElementVNode("div", _hoisted_47, [_cache[42] || (_cache[42] = _createElementVNode("div", {
        class: "step-header"
      }, [_createElementVNode("div", {
        class: "step-number"
      }, "04"), _createElementVNode("div", {
        class: "step-title"
      }, "预效果"), _createElementVNode("div", {
        class: "step-desc"
      }, "查看生成的数字人视频效果")], -1)), _createElementVNode("div", _hoisted_48, [_cache[40] || (_cache[40] = _createElementVNode("span", null, "预览效果", -1)), state.value.hasPreview ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        class: "download-btn",
        onClick: _cache[6] || (_cache[6] = $event => _unref(blobDownloadUpgrades)(formData.value.videoMakeMediaUrl))
      }, {
        default: _withCtx(() => _cache[39] || (_cache[39] = [_createTextVNode(" 下载视频 ")])),
        _: 1
      })) : _createCommentVNode("", true)]), _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["preview-area", {
          'has-preview': state.value.hasPreview
        }]),
        "element-loading-text": "生成中...",
        "element-loading-background": "rgba(0, 0, 0, 0.8)"
      }, [!state.value.hasPreview ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_icon, {
        class: "preview-icon"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Picture))]),
        _: 1
      }), _cache[41] || (_cache[41] = _createElementVNode("span", null, "请在左侧上传照片，预览视频效果～", -1))], 64)) : (_openBlock(), _createElementBlock("video", {
        key: 1,
        ref: "videoRef",
        src: formData.value.videoMakeMediaUrl,
        controls: "",
        class: "preview-video"
      }, null, 8, _hoisted_49))], 2)), [[_directive_loading, state.value.previewLoading]])])])]), dialogVisible.value ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => dialogVisible.value = $event),
        title: "选择音色",
        width: "1000",
        "close-on-click-modal": false,
        class: "voice-selector-dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_60, [_createVNode(_component_el_button, {
          class: "cancel-btn",
          onClick: _cache[7] || (_cache[7] = $event => (dialogVisible.value = false, tempSelectedVoice.value = {}, _unref(audioPause)()))
        }, {
          default: _withCtx(() => _cache[43] || (_cache[43] = [_createTextVNode(" 取消 ")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          class: "confirm-btn",
          onClick: _cache[8] || (_cache[8] = $event => (_unref(audioPause)(), _unref(comfirmSelectVoice)()))
        }, {
          default: _withCtx(() => _cache[44] || (_cache[44] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_50, [_createVNode(_component_el_scrollbar, {
          height: "550px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_51, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(voiceList.value, voice => {
            var _tempSelectedVoice$va4, _tempSelectedVoice$va5;
            return _openBlock(), _createElementBlock("div", {
              key: voice.id,
              class: _normalizeClass(['voice-item', {
                'active': voice.id === ((_tempSelectedVoice$va4 = tempSelectedVoice.value) === null || _tempSelectedVoice$va4 === void 0 ? void 0 : _tempSelectedVoice$va4.id),
                playing: _unref(audioPlaying)
              }]),
              onClick: $event => quickSelectVoice(voice)
            }, [_createElementVNode("div", {
              class: "voice-item-icon",
              onClick: $event => openVoiceSelector(voice)
            }, [_createElementVNode("div", _hoisted_54, [_createVNode(_component_svg_icon, {
              class: "voice-item-icon-svg",
              width: "100%",
              height: "100%",
              "icon-class": "dvd"
            })])], 8, _hoisted_53), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, _toDisplayString(voice.timbreName), 1), _createElementVNode("div", _hoisted_57, _toDisplayString(voice.timbreDesc || '点击选择该音色'), 1)]), _createElementVNode("div", _hoisted_58, [voice.id === ((_tempSelectedVoice$va5 = tempSelectedVoice.value) === null || _tempSelectedVoice$va5 === void 0 ? void 0 : _tempSelectedVoice$va5.id) ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0
            }, {
              default: _withCtx(() => [_createVNode(_component_Check)]),
              _: 1
            })) : _createCommentVNode("", true)])], 10, _hoisted_52);
          }), 128))])]),
          _: 1
        }), _createElementVNode("div", _hoisted_59, [_createVNode(TimbreEditor, {
          selectedVoice: tempSelectedVoice.value,
          onHandleEmotionClick: handleEmotionClick
        }, null, 8, ["selectedVoice"])])])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), _unref(showImageViewer) ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 1,
        "url-list": _unref(showImageArr),
        onClose: _cache[10] || (_cache[10] = () => _isRef(showImageViewer) //@ts-ignore
        ? showImageViewer.value = false : showImageViewer = false)
      }, null, 8, ["url-list"])) : _createCommentVNode("", true)]);
    };
  }
});